/* eslint-disable camelcase */
import Model from '../../../Api/Models/Model';
import { GetCasinoGameCategoryResponse } from '../CRM/Responses/CasinoGameCategoryResponse';

import CasinoGame from './CasinoGame';

import CasinoGameCategoryTranslation from './CasinoGameCategoryTranslation';

export default class CasinoGameCategory extends Model {
    readonly id: number;
    readonly order?: number;
    readonly is_visible_on_homepage: boolean;
    readonly is_all_games: boolean;
    readonly is_live_only: boolean;
    readonly is_filled_manually: boolean;
    readonly automatic_filling_method?: CasinoGameCategoriesAutomaticFillingMethodType;
    readonly allowed_types?: string[];
    readonly sorting_type: CasinoGameCategorySortingType;
    readonly created_at: string;
    readonly updated_at: string;

    // Relationships
    readonly casino_game_category_translations?: CasinoGameCategoryTranslation[];
    readonly casino_games?: CasinoGame[];

    constructor(casinoGame: Partial<GetCasinoGameCategoryResponse>) {
        super();
        this.assignDataToProps(casinoGame, [
            'id',
            'order',
            'is_visible_on_homepage',
            'is_all_games',
            'is_live_only',
            'is_filled_manually',
            'automatic_filling_method',
            'allowed_types',
            'sorting_type',
            'created_at',
            'updated_at',
            'casino_game_category_translations',
        ]);
    }
}

export enum CasinoGameCategoriesAutomaticFillingMethodType {
    JACKPOT = 'jackpot',
    TIPTO = 'tip_to',
    TIPFROM = 'tip_from',
    FREESPIN = 'freespin',
}

export enum CasinoGameCategorySortingType {
    DEFAULT = 'default',
    CUSTOM = 'custom',
}
